import React from 'react';
import { Row, Col } from '@si-armes/dsfr-react';
import InputFiles from 'components/Commun/Form/InputFiles';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import CertificatMedicalModele from '../../../media/modele_certificat_medical.pdf';

const FormulaireCertificatMedical = ({ isAncienLicencie }) => {
    const hookForm = useFormContext();
    const { formState } = hookForm;
    const getMessage = () => {
        if (isAncienLicencie) {
            return (
                <>
                    <p>
                        L'ajout du certificat médical attestant que votre état de santé physique et
                        psychique n'est pas incompatible avec la détention d'armes ou de munitions
                        est facultatif. Si vous l'ajoutez, il vous permettra d'acquérir des armes de
                        catégorie C3, C9 ou C12 en tant qu'Ancien Licencié.
                    </p>
                    <p>
                        Le modèle proposé ci-dessous doit être rempli et signé par un médecin avant
                        d'être importé dans votre compte SIA.
                    </p>
                </>
            );
        }

        return (
            <p>
                Vous disposez de 3 mois pour importer un certificat médical attestant que votre état
                de santé physique et psychique n&apos;est pas incompatible avec détention de ces
                armes ou munitions. Le modèle proposé ci-dessous doit être être rempli et signé par
                un médecin avant d&apos;être importé dans votre compte SIA.
            </p>
        );
    };

    return (
        <>
            <Row className="margin-top-lg">
                <Col col={12}>
                    <h3>Certificat médical</h3>
                </Col>
            </Row>

            <Row gutters>
                <Col lg={6}>
                    {getMessage()}
                    <a href={CertificatMedicalModele} rel="noopener noreferrer" target="_blank">
                        Télécharger le modèle de certificat médical.
                    </a>
                </Col>
                <Col lg={6}>
                    <InputFiles
                        label="Certificat médical"
                        name="certificatMedical"
                        error={formState.errors?.certificatMedical ?? null}
                        message={formState.errors?.certificatMedical?.message}
                    />
                </Col>
            </Row>
        </>
    );
};

FormulaireCertificatMedical.propTypes = {
    isAncienLicencie: PropTypes.bool,
};
export default FormulaireCertificatMedical;
